module.exports = __webpack_public_path__ + "12ded61f595a20d5e13ec2d581f0d52c.jpg";